<template>
  <div>
    
    <div class="row">
      <div class="col-lg-3 col-md-12 mb-3">

        <div class="card">
          <div class="card-body">
            <p class="card-title">
              Create {{ $route.meta.title }}
            </p>

            <form
              @submit.prevent="postForm"
            >
              <div class="form-group">
                <label for="name">Name</label>
                <input
                  id="name"
                  v-model="form.name"
                  type="text"
                  class="form-control"
                  required
                >
              </div>

              <div class="form-group">
                <label for="amount">Amount</label>
                <input
                  id="amount"
                  v-model="form.amount"
                  type="text"
                  class="form-control"
                  required
                >
              </div>

              <div class="form-group">
                <label for="frequency">Frequency</label>
                <select id="frequency" class="form-control" v-model="form.frequency" :disabled="processing" required>
                  <option value=""></option>
                  <template v-for="frequency in frequencies">
                    <option :value="frequency">{{ frequency }}</option>
                  </template>
                </select>
              </div>

              <button
                type="submit"
                class="btn btn-success"
                :disabled="processing"
              >
                Create
              </button>
            </form>
          </div><!--Body-->
        </div><!--Card-->

        <div class="card mt-3">
          <div class="card-body">
            <p class="card-title">
              Search {{ $route.meta.title }}s
            </p>

            <form @submit.prevent="searchRecords">
              <div class="form-group">
                <label for="search">Search</label>
                <input
                  id="search"
                  v-model="queries.search"
                  class="form-control"
                  type="search"
                  placeholder="Search by name..."
                >
              </div>

              <div class="form-group">
                <label for="search_frequency">Frequency</label>
                <select id="search_frequency" class="form-control" v-model="queries.frequency" :disabled="processing" required>
                  <option value=""></option>
                  <template v-for="frequency in frequencies">
                    <option :value="frequency">{{ frequency }}</option>
                  </template>
                </select>
              </div>
         

                  <div class="form-group">
                    <label for="search_location">Location</label>
                    <select
                      id="search_location"
                      v-model="queries.location"
                      class="form-control"
                      :disabled="processing"
                    >
                      <option value=""></option>
                      <template v-for="location in locations">
                        <option
                          :value="location.uuid"
                        >
                          {{ location.name }}
                        </option>
                      </template>
                    </select>
                  </div>

                  <div class="form-group">
                    <label for="search_portal">Portal</label>
                    <select
                      id="search_portal"
                      v-model="queries.portal"
                      class="form-control"
                      :disabled="processing"
                    >
                      <option value=""></option>
                      <template v-for="portal in portals">
                        <option
                          :value="portal.uuid"
                        >
                          {{ portal.name }}
                        </option>
                      </template>
                    </select>
                  </div>

              <button
                type="submit"
                class="btn btn-primary"
                :disabled="processing"
              >
                Search
              </button>
            </form>
          </div><!--Body-->
        </div><!--Card-->

      </div><!--Col-->
      <div class="col-lg-9 col-md-12">

        <div class="card">
          <div class="card-body">

            <p class="card-title">
              {{ records.length }} of {{ total.toLocaleString() }} {{ $route.meta.title }}s
            </p>

              <data-table :fields="columns" :queries="queries" :base_url="$route.meta.base_url" :records="records" />

            <template v-if="!processing && records && !records.length">
              <div class="alert alert-warning">
                No {{ $route.meta.title }}s found.
              </div>
            </template>

          </div><!--Body-->
        </div><!--Card-->


        <template v-if="records && records.length < total">
          <div class="row mt-3">
            <div class="col-12 text-center">
              <button
                type="button"
                class="btn btn-outline-primary d-print-none"
                :disabled="processing"
                @click="getRecords"
              >
                Load more
              </button>
            </div><!--Col-->
          </div><!--Row-->
        </template>
      </div><!--Col-->
    </div><!--Row-->

  </div>
</template>
<script>
export default {
  
  data () {
    return {
      records: [],
      processing: false,
      total: 0,
      queries: {},
      form: {},
      columns: [
          {key: 'name', label: 'Name'},
          {key: 'amount', label: 'Amount'},
          {key: 'frequency', label: 'Frequency'},
          {key: 'duration', label: 'Duration'},
          {key: 'location', label: 'Location'},
          {key: 'portal', label: 'Portal'},
          {key: 'created_by', label: 'Creator'},
          {key: 'created_at', label: 'Created'},
          {key: 'updated_at', label: 'Updated'}
      ],
      frequencies: ['week', 'biweek', 'month', 'quarter', 'year'],
      locations: [],
      portals: []
    }
  },

  mounted() {
    this.refreshRecords();
  },

  created () {
    this.resetRecords();
    this.resetQueries();
    this.resetForm();
    this.setURLParams();
    this.getRecords();
    this.getLocations();
    this.getPortals();
  },

  methods: {

    resetRecords() {
      this.records = [];
      this.queries.skip = 0;
      this.total = 0;
    },

    resetForm() {
      this.form = {
        name: null,
        description: null,
        amount: 0,
        duration: 0,
        frequency: null,
        location: null,
        portal: null
      }
    },

    resetQueries() {
      this.queries = {
        limit: 10,
        skip: 0,
        sort: 'created_at',
        sortDirection: 'desc',
        search: null,
        location: null,
        portal: null,
        frequency: null
      }
    },

    updateURL() {
      history.pushState({}, null, this.buildQueries(this.$route.meta.base_url, this.queries));
    },

    getRecords () {

      this.processing = true;

      this.updateURL();

      this.totalRecords();

      this.$http.get(this.buildQueries(this.$route.meta.base_url, this.queries))
      .then(response => {
        if (response && response.data) {

          this.processing = false;

          if(response.data.length) {

            this.queries.skip += response.data.length;

            var self = this;

            response.data.forEach(function(data) {
              self.records.push(data);
            });

          }
        }
      })
    },

    totalRecords() {
      this.$http.get(this.buildQueries(this.$route.meta.base_url+'/total', this.queries))
      .then(response => {
        if(response && response.status === 200) {
          this.total = response.data;
        }
      })
    },

    postForm() {
        this.processing = true;

        this.$http.post(this.$route.meta.base_url, this.form)
        .then(response => {
            if(response && response.status) {

                if(response.status === 201) {
                  this.resetForm();
                  this.total++;
                  this.records.unshift(response.data);
                }

                this.processing = false;

            }
        });
    },

    getLocations () {
        this.$http.get('/locations?limit=1000&sort=default&sortDirection=asc&fields=uuid,name')
        .then(response => {
            if (response && response.data) {
                this.locations = response.data;

                if(this.locations.length > 0 && !this.form.location) {
                  this.form.location = this.locations[0].uuid;
                }
            }
        })
    },

    getPortals () {
        this.$http.get('/portals?limit=1000&sort=default&sortDirection=asc&fields=uuid,name,link')
        .then(response => {
            if (response && response.data) {
                this.portals = response.data;

                if(this.portals.length > 0 && !this.form.portal) {
                  this.form.portal = this.portals[0].uuid;
                }
            }
        })
    },


  }
}
</script>
